import React, { FC, Fragment } from 'react'

import styles from './InputHelp.module.scss'
import InputHelpProps from './InputHelp.types'
import { Typography } from '../typography/typography'

export const InputHelp: FC<InputHelpProps> = ({
  id = '',
  help,
}: InputHelpProps) => {
  if (help) {
    return (
      <p id={`hinttext-${id}`} className={styles.inputHelpContainer}>
        {Array.isArray(help) ? (
          help.map((item) => (
            <Fragment key={item as string}>
              <Typography variant="Montserrat/Small" component="span">
                {item}
              </Typography>
              <br />
            </Fragment>
          ))
        ) : (
          <Typography variant="Montserrat/Small" component="span">
            {help}
          </Typography>
        )}
      </p>
    )
  }
  return null
}

export default InputHelp
